import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getNodeApiUrl } from "../../config/api.config";

export const getSystemDetails = createAsyncThunk(
    'systemDetails/getSystemDetails',
    async ({ systemId, token }, { rejectWithValue }) => {
    console.log('getSystemDetails chiamato con systemId:', systemId);
    const url = getNodeApiUrl('/systems');
    const headers = { 'Content-Type': 'application/json', 'auth-token': token };
    
    // Costruisco gli oggetti separati per una maggiore chiarezza
    const params = new URLSearchParams();
    params.append('systemId', systemId);
    
    const finalUrl = `${url}?${params.toString()}`;
    const options = { method: 'GET', headers };
    console.log('URL finale con parametri:', finalUrl);
    try {
        const response = await fetch(finalUrl, options);
        if (!response.ok) {
            const error = await response.json();
            return rejectWithValue({
                message: error.message || `Errore sconosciuto.`
            })
        } else {
            const result = await response.json();
            return result
        }
    } catch (error) {
        return rejectWithValue({
            message: (error instanceof Error) ? error.message : 'Errore di rete. Riprova più tardi.'
        });
    }
});

const initialState = {
    isLoading: false,
    error: null,
    data: null
}

const systemDetailsSlice = createSlice({
    name: "systemDetails",
    initialState,
    reducers: {
        resetSystemDetails: (state) => {
            state.data = null;
            state.error = null;
            state.isLoading = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSystemDetails.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getSystemDetails.rejected, (state, action) => {
                state.data = null;
                state.error = action.payload?.message || "Errore sconosciuto nel caricamento di system details.";
                state.isLoading = false;
            })
            .addCase(getSystemDetails.fulfilled, (state, action) => {
                state.error = null;
                state.data = action.payload;
                state.isLoading = false;
            })
    }
})

// Selectors
export const selectSystemDetailsData = (state) => state.systemDetails.data;
export const selectSystemDetailsIsLoading = (state) => state.systemDetails.isLoading;
export const selectSystemDetailsError = (state) => state.systemDetails.error;

// Actions
export const { resetSystemDetails } = systemDetailsSlice.actions;

export default systemDetailsSlice.reducer;